<div>
  <div *ngIf="data.candidature.statusOfCandidatOnMission == CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION" class="d-flex gap-2 flex-wrap align-items-center" >
    <div class="fs-13">En Attente</div>
    <app-button text="Accepter" color="accent" innerClass="cloud" (handleClick)="acceptCandidature()"></app-button>
  </div>

  <div class="d-flex gap-2"
    *ngIf="data.candidature.statusOfCandidatOnMission == CandidatStatusOnMission.ACCEPTED ||
  data.candidature.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH">
    <div class="text-accent-green fs-13">{{
        data.candidature.statusOfCandidatOnMission == CandidatStatusOnMission.ACCEPTED ? 'Acceptée' : 'Confirmé'
      }}
    </div>

    <svg-icon
      class="inner-icon left"
      svgClass="placeholder-icon"
      [src]="
      data.candidature.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED
        ? '/assets/icons/tick-green-simple.svg'
        : data.candidature.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
        ? '/assets/icons/tick-green-double.svg'
        : ''
    "
    ></svg-icon>
  </div>
</div>
